import { useCurrentAccount } from "PFCore/hooks/queries/account";
import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const CustomLinksNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  const { data: currentAccount } = useCurrentAccount();
  const customLinks = currentAccount.customization?.customLinks || [];

  if (customLinks.length === 0) {
    return null;
  }

  return (
    <NavItem
      icon="links"
      name={t("links")}
      id="external"
      items={customLinks.map((link) => ({
        name: link.title,
        href: link.url,
        target: "_blank",
        external: true
      }))}
      {...props}
    />
  );
};
